import type {HeatRegistration} from '@iziping/common';
import {formatPlayersSimple} from '@iziping/common';
import React from "react";
import styles from './HeatRegistration.module.css';

type Props = {
    registration: HeatRegistration;
    seed: number;
};

export default function HeatRegistrationItem({ registration, seed }: Props) {
    return (
        <div>
            <span className={styles.seed}>{seed}  </span>
            <span className={styles.name}>
                {formatPlayersSimple(registration)}
            </span>
        </div>
    );
}